"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RequiredTradingPartnerLineItemBolInfo = void 0;
exports.RequiredTradingPartnerLineItemBolInfo = {
    CartonCount: 'CARTON_COUNT',
    CartonDimensions: 'CARTON_DIMENSIONS',
    ItemDescription: 'ITEM_DESCRIPTION',
    PalletCount: 'PALLET_COUNT',
    PalletDimensions: 'PALLET_DIMENSIONS',
    PalletWeight: 'PALLET_WEIGHT'
};
//# sourceMappingURL=required-trading-partner-line-item-bol-info.js.map